export default "__VITE_ASSET__CMjjnXiZ__"